// Lokalizačné stringy pre PDF dokumenty a e-maily
export interface LocalizedStrings {
  // PDF Document Headers
  invoice: string;
  priceQuote: string;
  creditNote: string;
  taxDocument: string;
  
  // Document Fields
  issueDate: string;
  dueDate: string;
  validUntil: string;
  supplier: string;
  client: string;
  businessId: string;
  taxId: string;
  vatId: string;
  invoiceNumber: string;
  paymentDetails: string;
  variableSymbol: string;
  paymentMethod: string;
  bankTransfer: string;
  
  // Amounts and Calculations
  subtotal: string;
  vat: string;
  totalAmount: string;
  hourlyRate: string;
  hours: string;
  description: string;
  quantity: string;
  unitPrice: string;
  amount: string;
  
  // Email content
  greeting: string;
  regards: string;
  notes: string;
  
  // Onboarding steps
  fillCompanyInfo: string;
  uploadLogo: string;
  addClient: string;
  createTask: string;
  createInvoice: string;
  
  // Validation messages
  missingBillingInfo: string;
  checkProfileAndClient: string;
  
  // Common
  yes: string;
  no: string;
  optional: string;
  required: string;
}

// Slovenské lokalizácie
export const SK_STRINGS: LocalizedStrings = {
  // PDF Document Headers
  invoice: "Faktúra - daňový doklad",
  priceQuote: "Cenová ponuka",
  creditNote: "Dobropis",
  taxDocument: "daňový doklad",
  
  // Document Fields
  issueDate: "Dátum vystavenia",
  dueDate: "Dátum splatnosti",
  validUntil: "Platnosť do",
  supplier: "Dodávateľ",
  client: "Odberateľ",
  businessId: "IČO",
  taxId: "DIČ",
  vatId: "IČ DPH",
  invoiceNumber: "Číslo faktúry",
  paymentDetails: "Platobné údaje",
  variableSymbol: "Variabilný symbol",
  paymentMethod: "Spôsob platby",
  bankTransfer: "Bankový prevod",
  
  // Amounts and Calculations
  subtotal: "Medzisúčet",
  vat: "DPH",
  totalAmount: "Celková suma",
  hourlyRate: "Hodinová sadzba",
  hours: "Hodiny",
  description: "Popis",
  quantity: "Množstvo",
  unitPrice: "Jednotková cena",
  amount: "Suma",
  
  // Email content
  greeting: "Dobrý deň",
  regards: "S pozdravom",
  notes: "Poznámky",
  
  // Onboarding steps
  fillCompanyInfo: "Vyplniť firemné údaje (názov, IČO, DIČ...)",
  uploadLogo: "Nahrať logo (voliteľné)",
  addClient: "Pridať 1 klienta",
  createTask: "Vytvoriť 1 úlohu",
  createInvoice: "Vytvoriť 1 faktúru",
  
  // Validation messages
  missingBillingInfo: "Niektoré fakturačné údaje chýbajú. Skontrolujte svoj profil alebo údaje klienta.",
  checkProfileAndClient: "Skontrolujte svoj profil alebo údaje klienta",
  
  // Common
  yes: "Áno",
  no: "Nie",
  optional: "voliteľné",
  required: "povinné"
};

// Anglické lokalizácie
export const EN_STRINGS: LocalizedStrings = {
  // PDF Document Headers
  invoice: "Invoice - Tax Document",
  priceQuote: "Price Quote",
  creditNote: "Credit Note", 
  taxDocument: "tax document",
  
  // Document Fields
  issueDate: "Issue Date",
  dueDate: "Due Date",
  validUntil: "Valid Until",
  supplier: "Supplier",
  client: "Client",
  businessId: "Business ID",
  taxId: "Tax ID",
  vatId: "VAT ID",
  invoiceNumber: "Invoice Number",
  paymentDetails: "Payment Details",
  variableSymbol: "Variable Symbol",
  paymentMethod: "Payment Method",
  bankTransfer: "Bank Transfer",
  
  // Amounts and Calculations
  subtotal: "Subtotal",
  vat: "VAT",
  totalAmount: "Total Amount",
  hourlyRate: "Hourly Rate",
  hours: "Hours",
  description: "Description",
  quantity: "Quantity",
  unitPrice: "Unit Price",
  amount: "Amount",
  
  // Email content
  greeting: "Dear",
  regards: "Best regards",
  notes: "Notes",
  
  // Onboarding steps
  fillCompanyInfo: "Fill company information (name, Business ID, Tax ID...)",
  uploadLogo: "Upload logo (optional)",
  addClient: "Add 1 client",
  createTask: "Create 1 task",
  createInvoice: "Create 1 invoice",
  
  // Validation messages
  missingBillingInfo: "Some billing information is missing. Please check your profile or client details.",
  checkProfileAndClient: "Please check your profile or client details",
  
  // Common
  yes: "Yes",
  no: "No",
  optional: "optional",
  required: "required"
};

// Helper funkcie
export function getLocalizedStrings(market: 'SK' | 'US'): LocalizedStrings {
  return market === 'US' ? EN_STRINGS : SK_STRINGS;
}

export function formatCurrency(amount: number, currency: 'EUR' | 'USD', locale?: string): string {
  const localeCode = currency === 'USD' ? 'en-US' : 'sk-SK';
  return new Intl.NumberFormat(localeCode, {
    style: 'currency',
    currency: currency
  }).format(amount);
}

export function getCountryName(market: 'SK' | 'US', language: 'sk' | 'en'): string {
  if (market === 'US') {
    return language === 'en' ? 'United States' : 'Spojené štáty';
  } else {
    return language === 'en' ? 'Slovakia' : 'Slovensko';
  }
}